<template>
  <div class="claw-input-wrapper">
    <!-- 追问引用区域 -->
    <div v-if="draftReference" class="draft-reference">
      <div class="reference-header">
        <span class="reference-title">{{ draftReference.title }}</span>
        <button
          class="reference-close"
          @click="clearDraftReference"
          aria-label="清除引用"
        >
          <i class="el-icon-close"></i>
        </button>
      </div>
      <div class="reference-summary">
        {{ draftReference.summary || draftReference.prompt }}
      </div>
    </div>

    <!-- 已上传文件列表（移入输入框内部，见下方 input-left） -->

    <!-- CFO 快捷指令 -->
    <div v-if="isCfoAgent" class="quick-chips">
      <button
        v-for="chip in cfoQuickChips"
        :key="chip.scenario"
        type="button"
        @click="handleCfoQuickChip(chip)"
      >
        {{ chip.label }}
      </button>
    </div>

    <!-- 待发送队列：当前回答还没结束就提问的问题在这里排队，回答结束后依次发送 -->
    <div v-if="queuedMessages.length > 0" class="pending-queue">
      <div
        v-for="item in queuedMessages"
        :key="item.id"
        class="pending-item"
      >
        <span class="pending-text" :title="item.textContent">{{
          item.textContent || '（附件）'
        }}</span>
        <div class="pending-actions">
          <button
            class="pending-action pending-action--primary"
            title="插队：中止当前回答，立即回答该问题"
            @click.stop="jumpQueuedMessage(item.id)"
          >
            <i class="el-icon-top"></i>
          </button>
          <button
            class="pending-action pending-action--danger"
            title="删除"
            @click.stop="removeQueuedMessage(item.id)"
          >
            <i class="el-icon-close"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- 主输入区 -->
    <div
      class="input-box"
      :class="{ disabled: isDisabled, 'drag-over': isDragOver }"
      @dragover.prevent="isDragOver = true"
      @dragleave="isDragOver = false"
      @drop.prevent="handleDrop"
    >
      <input
        ref="fileInput"
        type="file"
        accept="*/*"
        multiple
        style="display: none"
        @change="handleFileSelect"
      />
      <!-- @数字人选择下拉框（两步选择：人员 → 数字人） -->
      <div
        v-if="showMentionDropdown"
        class="mention-dropdown"
        :style="mentionDropdownStyle"
      >
        <button
          class="mention-close-btn"
          @click="closeMentionDropdown"
          aria-label="关闭"
        >
          <i class="el-icon-close"></i>
        </button>
        <!-- 步骤1：人员列表 -->
        <template v-if="mentionStep === 'users'">
          <div
            class="mention-header"
            style="
              display: flex;
              align-items: center;
              gap: 4px;
              flex-direction: column;
            "
          >
            <div
              style="
                width: 100%;
                font-size: 12px;
                color: #000;
                margin-bottom: 4px;
              "
            >
              选择人员
            </div>
            <div
              class="mention-search-box"
              style="
                width: 100%;
                position: relative;
                margin-bottom: 4px;
                box-sizing: border-box;
                background: #fff;
                outline: none;
                box-sizing: border-box;
                background: #fff;
                outline: none;
                box-sizing: border-box;
                background: #fff;
                outline: none;
                box-sizing: border-box;
                background: #fff;
                outline: none;
                box-sizing: border-box;
                background: #fff;
                outline: none;
                box-sizing: border-box;
                background: #fff;
                outline: none;
                box-sizing: border-box;
                background: #fff;
                outline: none;
                box-sizing: border-box;
                background: #fff;
                outline: none;
                box-sizing: border-box;
              "
            >
              <i
                class="el-icon-search"
                style="
                  position: absolute;
                  left: 8px;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #bbb;
                  font-size: 13px;
                "
              ></i>
              <input
                ref="mentionSearchInput"
                v-model="mentionSearchTerm"
                placeholder="搜索人员姓名..."
                style="
                  width: 100%;
                  height: 28px;
                  border: 1px solid #e4e7ed;
                  border-radius: 4px;
                  padding: 0 8px 0 28px;
                  font-size: 12px;
                  outline: none;
                  box-sizing: border-box;
                  background: #fff;
                "
                @input.stop
                @click.stop
              />
            </div>
          </div>
          <div class="mention-body" @scroll="handleMentionScroll">
            <div
              v-if="mentionLoading && mentionPage === 1"
              class="mention-loading"
            >
              <i class="el-icon-loading"></i> 加载中...
            </div>
            <template v-else-if="tenantUsers.length === 0">
              <div class="mention-empty">暂无可用人员</div>
            </template>
            <template v-else>
              <div
                v-for="(user, index) in tenantUsers"
                :key="user.userId || user.id || index"
                class="mention-item"
                :class="{
                  active:
                    mentionSelectedIndex === index && user.clawUser === true,
                  disabled: user.clawUser !== true,
                }"
                @click.stop="handleUserClick(user)"
                @mouseenter="mentionSelectedIndex = index"
              >
                <div v-if="user.pictureUrl" class="mention-avatar">
                  <img
                    :src="user.pictureUrl"
                    style="
                      width: 100%;
                      height: 100%;
                      border-radius: 50%;
                      object-fit: cover;
                    "
                  />
                </div>
                <div
                  v-else
                  class="mention-avatar"
                  style="background: linear-gradient(135deg, #6366f1, #818cf8)"
                >
                  <span
                    style="font-size: 14px; color: #ffffff; font-weight: 700"
                    >{{
                      (user.displayName || user.username || 'U').slice(0, 1)
                    }}</span
                  >
                </div>
                <div class="mention-info">
                  <div class="mention-name">
                    {{
                      user.displayName ||
                      user.username ||
                      user.userName ||
                      user.userId ||
                      '未知用户'
                    }}({{ user.employeeNumber || '' }})
                  </div>
                </div>
              </div>
              <div
                v-if="mentionLoading && mentionPage > 1"
                class="mention-loading"
              >
                <i class="el-icon-loading"></i> 加载更多...
              </div>
              <div
                v-if="
                  !mentionHasMore && tenantUsers.length > 0 && !mentionLoading
                "
                class="mention-no-more"
                style="
                  text-align: center;
                  padding: 8px;
                  font-size: 12px;
                  color: #999;
                "
              >
                没有更多了
              </div>
            </template>
          </div>
        </template>
        <!-- 步骤2：数字人列表 -->
        <template v-if="mentionStep === 'agents'">
          <div
            class="mention-header"
            style="display: flex; align-items: center; gap: 4px"
          >
            <span class="mention-back-btn" @click.stop="backToUserSelection"
              >返回</span
            >
            <span
              style="
                flex: 1;
                text-align: center;
                color: #000;
                font-weight: 700;
                margin-bottom: 8px;
              "
              >选择数字人</span
            >
          </div>
          <div class="mention-body">
            <div v-if="mentionLoading" class="mention-loading">
              <i class="el-icon-loading"></i> 加载中...
            </div>
            <template v-else-if="filteredUserAgents.length === 0">
              <div class="mention-empty">该用户无可用的数字人</div>
            </template>
            <template v-else>
              <div
                v-for="(agent, index) in filteredUserAgents"
                :key="agent.id || agent.agentId || index"
                class="mention-item"
                :class="{ active: mentionSelectedIndex === index }"
                @click.stop="selectMentionAgent(agent)"
                @mouseenter="mentionSelectedIndex = index"
              >
                <div v-if="agent.icon" class="mention-avatar">
                  <img
                    :src="agent.icon"
                    style="
                      width: 100%;
                      height: 100%;
                      border-radius: 50%;
                      object-fit: cover;
                    "
                  />
                </div>
                <div
                  v-else
                  class="mention-avatar"
                  style="background: linear-gradient(135deg, #10b981, #34d399)"
                >
                  <span
                    style="font-size: 14px; color: #ffffff; font-weight: 700"
                    >{{
                      (agent.displayName || agent.name || agent.agentName || 'D')
                        .slice(0, 1)
                        .toUpperCase()
                    }}</span
                  >
                </div>
                <div class="mention-info">
                  <div class="mention-name">
                    {{ agent.displayName || agent.name || agent.agentName || '未知数字人' }}
                  </div>
                  <div class="mention-desc">
                    ID: {{ agent.id || agent.agentId }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>

      <!-- 左侧：输入区 + 底部功能图标 -->
      <div class="input-left">
        <!-- 已上传文件列表（输入框内部、文本域上方） -->
        <div v-if="uploadedFiles.length > 0" class="uploaded-files">
          <!-- 图片预览 -->
          <div
            v-for="file in imageFiles"
            :key="file.id"
            class="image-preview-card"
          >
            <img :src="file.url" :alt="file.name" class="preview-image" />
            <div v-if="file.isUploading" class="upload-overlay">
              <el-progress
                type="circle"
                :percentage="Math.round(file.progress)"
                :width="24"
                :stroke-width="3"
                color="#4A5FF3"
              ></el-progress>
            </div>
            <i
              v-else
              class="el-icon-close file-corner-remove"
              @click="removeFile(file.id)"
            ></i>
          </div>
          <!-- 非图片文件卡片 -->
          <div
            v-for="file in nonImageFiles"
            :key="file.id"
            class="file-card"
          >
            <div
              class="file-type-icon"
              :style="{ backgroundColor: getFileTypeColor(file.name) }"
            >
              <span class="type-label">{{ getFileTypeLabel(file.name) }}</span>
            </div>
            <div class="file-info">
              <div class="file-name" :title="file.name">{{ file.name }}</div>
              <div class="file-meta">
                {{ getFileExtension(file.name).toUpperCase() }} •
                {{ formatFileSize(file.size) }}
              </div>
            </div>
            <i
              v-if="!file.isUploading"
              class="el-icon-close file-corner-remove"
              @click="removeFile(file.id)"
            ></i>
            <!-- 上传进度条 -->
            <div v-if="file.isUploading" class="upload-progress-bar">
              <div class="upload-progress-fill" :style="{ width: (file.progress || 0) + '%' }"></div>
            </div>
          </div>
        </div>
        <!-- @数字人选中标签 -->
        <div v-if="selectedMention" class="mention-chip">
          <span class="mention-chip-icon">@</span>
          <span class="mention-chip-name">{{
            selectedMention.displayName
          }}</span>
          <button class="mention-chip-close" @click.stop="removeMention">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <!-- 待发送追问 chips（选中正文追问后出现在输入框上方） -->
        <div v-if="pendingFollowUps.length > 0" class="followup-chips">
          <button
            v-for="item in pendingFollowUps"
            :key="item.messageId + ':' + item.annotationId"
            type="button"
            class="followup-chip"
            :title="item.quote || item.note"
            @click="handleFollowUpChipClick(item, $event)"
          >
            <span
              class="followup-chip-index"
              role="button"
              :title="'定位到追问位置'"
              @click.stop="handleFollowUpIndexClick(item)"
            >{{ item.index }}</span>
            <span class="followup-chip-text">
              <span class="followup-chip-quote">{{ followUpChipQuote(item) }}</span>
              <span class="followup-chip-dot">·</span>
              <span class="followup-chip-note">{{ followUpChipNote(item) }}</span>
            </span>
          </button>
        </div>
        <textarea
          ref="textarea"
          v-model="textContent"
          :placeholder="placeholder"
          :disabled="isDisabled"
          @keydown="handleKeyDown"
          @input="handleInput"
          @paste="handlePaste"
          rows="1"
        ></textarea>

        <!-- 底部功能图标行 -->
        <div class="input-toolbar">
          <!-- 附件：点击弹出「上传文档 / 上传图片」菜单（向下弹出，tooltip 在左侧避免遮挡） -->
          <div class="attach-menu-wrap" ref="attachMenuWrap">
            <el-tooltip
              :content="
                isUploading ? $t('workbench.uploading') : $t('workbench.addFile')
              "
              placement="left"
            >
              <button
                class="toolbar-btn"
                :disabled="isUploading"
                @click.stop="toggleAttachMenu"
              >
                <i v-if="isUploading" class="el-icon-loading"></i>
                <i v-else class="el-icon-paperclip"></i>
              </button>
            </el-tooltip>
            <transition name="attach-menu-fade">
              <div
                v-if="showAttachMenu"
                class="attach-menu"
                :class="{ 'attach-menu--up': attachMenuUp }"
                @click.stop
              >
                <div class="attach-menu-item" @click="handleAttachMenuPick('doc')">
                  <i class="el-icon-document"></i>
                  <span>上传文档</span>
                </div>
                <div class="attach-menu-item" @click="handleAttachMenuPick('image')">
                  <i class="el-icon-picture-outline"></i>
                  <span>上传图片</span>
                </div>
              </div>
            </transition>
          </div>

          <div class="knowledge-toggle">
            <span class="knowledge-toggle-label">数字人知识库</span>
            <el-tooltip
              :content="knowledgeId ? '知识库' : '当前数字人暂无知识库'"
              placement="top"
            >
              <el-switch
                :value="knowledgeEnabled"
                :active-value="1"
                :inactive-value="0"
                size="mini"
                :disabled="isStreaming || !knowledgeId"
                active-color="#4A5FF3"
                inactive-color="#e4e7ed"
                class="knowledge-switch"
                @change="handleKnowledgeBaseChange"
              />
            </el-tooltip>
          </div>
        </div>
      </div>

      <!-- 右侧：操作按钮 -->
      <div class="input-actions">
        <!-- <el-tooltip :content="$t('workbench.clearSession')" placement="top">
          <button class="action-btn" :disabled="isStreaming || !isHandshaked" @click="handleClearSession">
            <i class="el-icon-brush"></i>
          </button>
        </el-tooltip> -->
        <el-select
          v-if="models.length > 0"
          v-model="selectedModel"
          size="mini"
          :disabled="isStreaming"
          @change="handleModelChange"
          class="model-select"
          popper-class="model-select-popper"
        >
          <el-option v-for="m in models" :key="m" :label="m" :value="m" />
        </el-select>
        <el-tooltip
          :content="
            isRecording
              ? $t('workbench.stopRecording')
              : $t('workbench.voiceInput')
          "
          placement="top"
        >
          <button
            class="action-btn voice-btn"
            :class="{ recording: isRecording }"
            :disabled="isStreaming"
            :aria-pressed="isRecording"
            :aria-label="
              isRecording
                ? $t('workbench.stopRecording')
                : $t('workbench.voiceInput')
            "
            @click="handleRecord"
          >
            <svg
              v-if="isRecording"
              class="audio-lines-icon active"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path class="bar bar1" d="M2 12h2"></path>
              <path class="bar bar2" d="M6 8v8"></path>
              <path class="bar bar3" d="M10 3v18"></path>
              <path class="bar bar4" d="M14 8v8"></path>
              <path class="bar bar5" d="M18 12h2"></path>
            </svg>
            <img
              v-else
              :src="require('@/assets/imgs/ai/luyin.png')"
              class="voice-icon-img"
              alt=""
            />
          </button>
        </el-tooltip>
        <el-tooltip
          v-if="isStreaming"
          :content="$t('workbench.abortChat')"
          placement="top"
        >
          <button
            class="action-btn stop-btn"
            :disabled="isStopping"
            @click="handleStop"
          >
            <i
              :class="isStopping ? 'el-icon-loading' : 'el-icon-video-pause'"
            ></i>
          </button>
        </el-tooltip>
        <el-tooltip
          :content="
            !isHandshaked ? $t('workbench.disconnected') : $t('workbench.send')
          "
          placement="top"
        >
          <button
            class="action-btn send-btn"
            :class="{ disabled: !canSend }"
            :disabled="!canSend"
            @click="handleSend"
          >
            <i class="el-icon-s-promotion"></i>
          </button>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { requestUploadFile } from '@/api/file'
import { getTenantMembersApi, getUserAgentsApi } from '@/api/agentAuth'
import { getToken } from '@/utils/auth'
import { VolcengineASR } from '@/utils/volcengineAsr'
import { followUpStore } from '../followUp/store'
import {
  formatFollowUpSection,
  normalizeFollowUpsMarkdown,
  truncateForChipTooltip
} from '../followUp/follow-ups'

export default {
  name: 'CosmoClawInput',
  props: {
    forceEnable: {
      type: Boolean,
      default: false
    },
    // 可选发送拦截钩子：返回 true 表示已由外部处理（如跳转对话页发送），本次不再实际发送
    beforeSend: {
      type: Function,
      default: null
    },
    // 自定义输入框占位文案（如智能体首页按智能体类型传入）；为空时使用默认 i18n 文案
    placeholderText: {
      type: String,
      default: ''
    },
    // 是否按会话保留输入草稿：仅历史会话输入框开启，切走/切回会话时保留未发送内容
    preserveDraft: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      textContent: '',
      // 输入草稿归属的会话 key（切换/销毁时以此为准，避免草稿写到新会话）
      draftSessionKey: '',
      streamingTimer: null,
      streamingStartTime: null,
      streamingElapsed: 0,
      lastStreamKey: '',
      uploadedFiles: [],
      isDragOver: false,
      isStopping: false,
      isRecording: false,
      asrInstance: null,
      recordingRequestId: 0,
      selectedAgent: 'ceo_shu_zi_ren',
      showMentionDropdown: false,
      mentionSelectedIndex: 0,
      mentionDropdownPosition: { top: 0, left: 0 },
      mentionStep: 'users',
      tenantUsers: [],
      userAgents: [],
      mentionLoading: false,
      selectedTenantUser: null,
      mentionSearchTerm: '',
      mentionPage: 1,
      mentionSize: 20,
      mentionTotal: 0,
      mentionHasMore: false,
      searchTimer: null,
      draftReference: null,
      selectedMention: null,
      // 附件二级菜单（上传文档 / 上传图片）
      showAttachMenu: false,
      // 菜单弹出方向：true=向上（按钮下方空间不足时，如会话页输入框贴底）
      attachMenuUp: false,
      // 待发送队列：回答未结束时提交的问题排队，回答结束后按序发送
      pendingQueue: [],
      isFlushingQueue: false,
      flushTimer: null
    }
  },
  computed: {
    ...mapState('cosmoClaw', [
      'isStreaming',
      'messages',
      'isHandshaked',
      'models',
      'currentModel',
      'currentSessionKey',
      'localDemoMode',
      'isCeoDemo',
      'knowledgeId',
      'currentAgentId'
    ]),
    ...mapGetters('cosmoClaw', ['knowledgeEnabled']),
    showStreamingIndicator() {
      return (
        this.isStreaming &&
        !this.messages.some((m) => m.type === 'assistant' && m.isStreaming)
      )
    },
    streamingKey() {
      const toolMsgs = this.messages.filter(
        (m) => m.type === 'toolCall' || m.type === 'tool'
      )
      const last = toolMsgs[toolMsgs.length - 1]
      return last
        ? last.toolCallId || last.toolName || last.id || 'tool'
        : 'thinking'
    },
    streamingText() {
      const hasTools = this.messages.some(
        (m) => m.type === 'toolCall' || m.type === 'tool'
      )
      return hasTools ? '工具调用中' : '正在思考中'
    },
    currentAgentName() {
      if (!this.currentSessionKey) return 'main'
      const match = this.currentSessionKey.match(/^agent:([^:]+):/)
      return match ? match[1] : 'main'
    },
    selectedModel: {
      get() {
        const current =
          this.currentModel || (this.models.length > 0 ? this.models[0] : '')
        // 历史会话采用的模型可能已不在当前模型列表中：自动展示模型列表第一个
        if (current && this.models.length > 0 && this.models.indexOf(current) === -1) {
          return this.models[0]
        }
        return current
      },
      set() {}
    },
    isDisabled() {
      if (this.forceEnable) return false
      // 流式输出中不再禁用输入框：允许用户先输入下一条问题，再发送时中止当前轮并在本会话继续
      return !this.isHandshaked || this.localDemoMode
    },
    isUploading() {
      return this.uploadedFiles.some((f) => f.isUploading)
    },
    canSend() {
      return (
        !this.isDisabled &&
        (this.textContent.trim().length > 0 ||
          this.uploadedFiles.length > 0 ||
          !!this.selectedMention ||
          this.hasPendingFollowUps)
      )
    },
    // 待发送追问（跨助手消息，按更新时间编号）
    pendingFollowUps() {
      return followUpStore.getPendingFollowUps()
    },
    hasPendingFollowUps() {
      return this.pendingFollowUps.length > 0
    },
    // 追问悬浮面板点「保存并发送」时自增，用于触发发送
    followUpSendRequestId() {
      return followUpStore.state.sendRequestId
    },
    // 待发送队列中属于当前会话的问题（回答结束后按序发送）
    queuedMessages() {
      return this.pendingQueue.filter(
        (item) => item.sessionKey === this.currentSessionKey
      )
    },
    placeholder() {
      if (!this.forceEnable && !this.isHandshaked) {
        return this.$t('workbench.connecting')
      }
      return this.placeholderText || this.$t('workbench.inputPlaceholder')
    },
    mentionAgents() {
      return [
        {
          key: 'cfo',
          label: '财务CFO数字人',
          shortName: '财务CFO数字人',
          role: '财务测算 / 现金流 / 上市约束',
          accent: '#10b981',
          avatar: 'linear-gradient(135deg,#0f9f73,#34d399)',
          aliases: ['CFO', '财务', '财务数字人', '知微']
        },
        {
          key: 'cso',
          label: '供应链CSO数字人',
          shortName: '供应链CSO数字人',
          role: '供应链统筹 / 风险预警 / 替代方案',
          accent: '#f59e0b',
          avatar: 'linear-gradient(135deg,#f59e0b,#fbbf24)',
          aliases: ['CSO', '供应链', '远航']
        },
        {
          key: 'coo',
          label: '运营COO数字人',
          shortName: '运营COO数字人',
          role: '产能调度 / 交付协同 / 排产优化',
          accent: '#2563eb',
          avatar: 'linear-gradient(135deg,#2563eb,#60a5fa)',
          aliases: ['COO', '运营', '智石']
        },
        {
          key: 'cmo',
          label: '销售CMO数字人',
          shortName: '销售CMO数字人',
          role: '销售策略 / 市场节奏 / 客户经营',
          accent: '#ec4899',
          avatar: 'linear-gradient(135deg,#db2777,#f472b6)',
          aliases: ['CMO', '销售', '千帆']
        },
        {
          key: 'cto',
          label: '技术CTO数字人',
          shortName: '技术CTO数字人',
          role: '技术方案 / 研发排期 / 系统能力',
          accent: '#7c3aed',
          avatar: 'linear-gradient(135deg,#7c3aed,#a78bfa)',
          aliases: ['CTO', '技术', '启明']
        }
      ]
    },
    mentionDropdownStyle() {
      return {
        top: this.mentionDropdownPosition.top + 'px',
        left: this.mentionDropdownPosition.left + 'px'
      }
    },
    filteredTenantUsers() {
      return this.tenantUsers
    },
    filteredUserAgents() {
      if (!this.mentionSearchTerm) return this.userAgents
      const term = this.mentionSearchTerm.toLowerCase()
      return this.userAgents.filter((a) =>
        (a.displayName || a.name || a.agentName || '').toLowerCase().includes(term)
      )
    },
    imageFiles() {
      return this.uploadedFiles.filter((f) => this.isImageFile(f.name) && f.url)
    },
    nonImageFiles() {
      return this.uploadedFiles.filter(
        (f) => !this.isImageFile(f.name) || !f.url
      )
    },
    isCfoAgent() {
      return this.currentAgentName === 'cai_wu_shu_zi_ren'
    },
    cfoQuickChips() {
      return [
        { scenario: 'margin', label: '毛利率下滑诊断' },
        { scenario: 'cost', label: '采购降本分析' },
        { scenario: 'report', label: '经营例会摘要' },
        { scenario: 'cash', label: '现金流压力测试' }
      ]
    }
  },
  watch: {
    isStreaming(val) {
      if (val) {
        // 新一轮回答开始，取消待发送的补发定时器
        this.clearFlushTimer()
        this.startStreamingTimer()
      } else {
        this.$nextTick(() => {
          if (this.$refs.textarea) {
            this.$refs.textarea.focus()
          }
        })
        this.stopStreamingTimer()
        // 回答结束：稍等收尾动画/消息落库后，发送队列中的下一条
        this.scheduleFlush(400)
      }
    },
    currentSessionKey(val, oldVal) {
      // 切换历史会话：先保存原会话未发送的输入内容，再恢复目标会话的草稿。
      // 用内部记录的 draftSessionKey（而不是 store 当前值）作为保存归属：
      // 跨数字人切换时组件可能在 store 已切到目标会话后才销毁，此时直接读 store
      // 会把旧会话的输入内容写进新会话草稿，导致旧内容出现在新输入框。
      if (this.preserveDraft) {
        this.saveInputDraft(this.draftSessionKey)
        this.draftSessionKey = val || ''
        this.restoreInputDraft(val)
      }
      // 切换会话后尝试发送当前会话的队列消息
      this.scheduleFlush(200)
    },
    mentionSearchTerm() {
      if (this.showMentionDropdown && this.mentionStep === 'users') {
        this._debouncedSearch()
      }
    },
    $route() {
      this.cancelRecording()
    },
    currentAgentId(val) {
      // 数字人切换后加载其知识库（store 的 switchAgent/switchSession 已处理，此处兜底）
      if (val) {
        this.$store.dispatch('cosmoClaw/loadAgentKnowledge', val)
      }
    },
    followUpSendRequestId(val) {
      if (!val) return
      // 悬浮追问面板「保存并发送」→ 立即发送（若当前不可发送则保持 pending）
      this.$nextTick(() => this.handleSend())
    }
  },
  created() {
    // 记录草稿归属的会话 key：组件销毁时 store 的 currentSessionKey 可能已被切换，
    // 必须以组件创建时/最后同步到的会话为准，避免草稿串到新会话
    this.draftSessionKey = this.currentSessionKey || ''
  },
  mounted() {
    window.setCeoDraftReference = this.setDraftReference.bind(this)
    window.setChatInputText = this.setChatInputText.bind(this)
    document.addEventListener('click', this._handleDocumentClick)
    document.addEventListener('click', this.handleClickOutsideAttachMenu)
    // 挂载时兜底加载当前数字人的知识库（防止切换动作早于组件挂载）
    if (this.currentAgentId) {
      this.$store.dispatch('cosmoClaw/loadAgentKnowledge', this.currentAgentId)
    }
    // 组件重建（如切换数字人后进入会话页）时恢复当前会话的输入草稿
    if (this.preserveDraft) {
      this.draftSessionKey = this.currentSessionKey || ''
      this.restoreInputDraft(this.currentSessionKey)
    }
  },
  beforeDestroy() {
    if (this.preserveDraft) this.saveInputDraft(this.draftSessionKey)
    this.cancelRecording()
    this.stopStreamingTimer()
    this.clearFlushTimer()
    window.setCeoDraftReference = null
    window.setChatInputText = null
    document.removeEventListener('click', this._handleDocumentClick)
    document.removeEventListener('click', this.handleClickOutsideAttachMenu)
  },
  methods: {
    startStreamingTimer() {
      this.stopStreamingTimer()
      this.streamingStartTime = Date.now()
      this.streamingElapsed = 0
      this.lastStreamKey = this._getStreamKey()
      this._streamSnapshot = JSON.stringify(this.messages)
      this.streamingTimer = setInterval(() => {
        this.streamingElapsed = Math.floor(
          (Date.now() - this.streamingStartTime) / 1000
        )
        // polling detected mode/tool switch
        const key = this._getStreamKey()
        if (key !== this.lastStreamKey) {
          this.streamingStartTime = Date.now()
          this.streamingElapsed = 0
          this.lastStreamKey = key
          this._streamSnapshot = JSON.stringify(this.messages)
        }
        // 兜底保护：长时间无任何消息变化仍处于流式状态时，强制收尾，避免切会话后“思考中”卡死
        const snapshot = JSON.stringify(this.messages)
        if (this.streamingElapsed >= 300 && snapshot === this._streamSnapshot) {
          this.stopStreamingTimer()
          this.$store.dispatch('cosmoClaw/finishStreamingMessage')
          return
        }
        this._streamSnapshot = snapshot
      }, 200)
    },
    _getStreamKey() {
      const toolMsgs = this.messages.filter(
        (m) => m.type === 'toolCall' || m.type === 'tool'
      )
      const last = toolMsgs[toolMsgs.length - 1]
      return last ? last.toolCallId || last.toolName || 'tool' : 'thinking'
    },
    stopStreamingTimer() {
      if (this.streamingTimer) {
        clearInterval(this.streamingTimer)
        this.streamingTimer = null
      }
      this.streamingStartTime = null
      this.streamingElapsed = 0
    },
    getMentionListLength() {
      if (this.mentionStep === 'users') return this.tenantUsers.length
      if (this.mentionStep === 'agents') return this.filteredUserAgents.length
      return 0
    },
    handleKeyDown(e) {
      // Enter（不带修饰键）发送；Alt / Ctrl / Meta + Enter 换行；Shift + Enter 保持浏览器默认换行
      if (
        e.key === 'Enter' &&
        !e.shiftKey &&
        !e.altKey &&
        !e.ctrlKey &&
        !e.metaKey
      ) {
        e.preventDefault()
        this.handleSend()
        // 发送后关闭下拉，防止继续触发选择
        this.closeMentionDropdown()
        return
      }
      // Alt / Ctrl / Meta + Enter：在光标处插入换行（与 Shift + Enter 一致）
      if (e.key === 'Enter' && (e.altKey || e.ctrlKey || e.metaKey)) {
        e.preventDefault()
        this.insertNewline()
        return
      }
      // 当有选中 mention chip 时，光标在 textarea 开头按退格键删除 chip
      if (e.key === 'Backspace' && this.selectedMention) {
        const ta = this.$refs.textarea
        if (ta && ta.selectionStart === 0 && ta.selectionEnd === 0) {
          this.removeMention()
          this.autoResize()
          e.preventDefault()
          return
        }
      }
      const listLen = this.getMentionListLength()
      if (e.key === 'ArrowDown' && this.showMentionDropdown && listLen > 0) {
        e.preventDefault()
        this.mentionSelectedIndex = (this.mentionSelectedIndex + 1) % listLen
        return
      }
      if (e.key === 'ArrowUp' && this.showMentionDropdown && listLen > 0) {
        e.preventDefault()
        this.mentionSelectedIndex =
          (this.mentionSelectedIndex - 1 + listLen) % listLen
        return
      }
      if (e.key === 'Enter' && this.showMentionDropdown && listLen > 0) {
        e.preventDefault()
        if (this.mentionStep === 'users') {
          const user = this.tenantUsers[this.mentionSelectedIndex]
          if (user && user.clawUser === true) this.selectTenantUser(user)
        } else if (this.mentionStep === 'agents') {
          const agent = this.filteredUserAgents[this.mentionSelectedIndex]
          if (agent) this.selectMentionAgent(agent)
        }
        return
      }
      if (e.key === 'Escape' && this.showMentionDropdown) {
        e.preventDefault()
        this.closeMentionDropdown()
        return
      }
      if (e.key === '@' || (e.keyCode === 50 && e.shiftKey)) {
        // 不要 preventDefault，让 @ 字符正常输入到 textarea
        this.showMentionDropdown = true
        this.mentionStep = 'users'
        this.mentionSelectedIndex = 0
        this.mentionSearchTerm = ''
        this.calculateMentionPosition()
        this.fetchTenantUsers()
        return
      }
    },
    insertNewline() {
      const ta = this.$refs.textarea
      if (!ta) return
      const start = ta.selectionStart
      const end = ta.selectionEnd
      const value = ta.value || ''
      this.textContent = value.slice(0, start) + '\n' + value.slice(end)
      this.$nextTick(() => {
        if (this.$refs.textarea) {
          this.$refs.textarea.selectionStart = start + 1
          this.$refs.textarea.selectionEnd = start + 1
        }
        this.autoResize()
      })
    },
    handleInput(e) {
      // IME 输入法拼写过程中不处理弹框逻辑（拼音未提交到输入框）
      if (e && e.isComposing) return
      this.autoResize()
      const text = this.textContent || ''
      const lastAtIndex = text.lastIndexOf('@')
      if (lastAtIndex !== -1 && lastAtIndex === text.length - 1) {
        // 末尾字符是 @ → 显示弹框（新输入 @ 或退格到 @）
        if (!this.showMentionDropdown) {
          this.showMentionDropdown = true
          this.mentionStep = 'users'
          this.mentionSelectedIndex = 0
          this.mentionSearchTerm = ''
          this.calculateMentionPosition()
          if (this.tenantUsers.length === 0) {
            this.fetchTenantUsers()
          }
        }
      } else {
        // 没有 @ 或 @ 后面有内容 → 关闭弹框
        if (this.showMentionDropdown) {
          this.closeMentionDropdown()
        }
      }
    },
    calculateMentionPosition() {
      const textarea = this.$refs.textarea
      if (!textarea) return
      const textareaRect = textarea.getBoundingClientRect()
      const dropdownHeight = 250
      let top = textareaRect.top - dropdownHeight - 8
      if (top < 20) {
        top = textareaRect.bottom + 8
      }
      this.mentionDropdownPosition = {
        top: top,
        left: textareaRect.left
      }
    },
    selectMentionAgent(agent) {
      const agentId = agent.id || agent.agentId || agent.key
      const displayName =
        agent.displayName || agent.name || agent.agentName || agent.label || `数字人${agentId}`
      // 存储为 chip，不再将 @agent-xxx 原始文本插入输入框
      this.selectedMention = {
        id: `agent-${agentId}`,
        agentId,
        displayName
      }
      // 清除 textarea 末尾的 @ 字符
      const text = this.textContent || ''
      const lastAtIndex = text.lastIndexOf('@')
      if (lastAtIndex !== -1) {
        this.textContent = text.slice(0, lastAtIndex)
      }
      this.autoResize()
      this.closeMentionDropdown()
      this.$nextTick(() => {
        if (this.$refs.textarea) {
          this.$refs.textarea.focus()
        }
      })
    },
    _handleDocumentClick(e) {
      if (!this.showMentionDropdown) return
      // 目标节点已不在 document 中（比如被 Vue 卸载），不处理
      if (!document.contains(e.target)) return
      const dropdown = this.$el?.querySelector('.mention-dropdown')
      const textarea = this.$refs.textarea
      if (
        dropdown &&
        !dropdown.contains(e.target) &&
        textarea &&
        !textarea.contains(e.target)
      ) {
        this.closeMentionDropdown()
      }
    },
    closeMentionDropdown() {
      this.showMentionDropdown = false
      this.mentionStep = 'users'
      this.tenantUsers = []
      this.userAgents = []
      this.selectedTenantUser = null
      this.mentionLoading = false
      this.mentionSearchTerm = ''
      this.mentionSelectedIndex = 0
      this.mentionPage = 1
      this.mentionTotal = 0
      this.mentionHasMore = false
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
        this.searchTimer = null
      }
    },
    removeMention() {
      this.selectedMention = null
      this.mentionSearchTerm = ''
      this.$nextTick(() => {
        if (this.$refs.textarea) {
          this.$refs.textarea.focus()
        }
      })
    },
    async fetchTenantUsers(reset = true) {
      if (reset) {
        this.mentionPage = 1
        this.mentionTotal = 0
        this.mentionHasMore = false
        this.tenantUsers = []
      }
      this.mentionLoading = true
      try {
        const accessToken = getToken()
        const params = {
          userAccessToken: accessToken,
          page: this.mentionPage,
          size: this.mentionSize
        }
        if (this.mentionSearchTerm) {
          params.keyword = this.mentionSearchTerm
        }
        const res = await getTenantMembersApi(params)
        const records = res?.data?.records || res?.data || []
        let users = []
        if (Array.isArray(records)) {
          users = records
        } else if (records.records) {
          users = records.records
        } else if (records.list) {
          users = records.list
        }
        if (reset) {
          this.tenantUsers = users
        } else {
          this.tenantUsers = this.tenantUsers.concat(users)
        }
        this.mentionTotal = res?.data?.total || users.length
        this.mentionHasMore = this.tenantUsers.length < this.mentionTotal
        this.mentionSelectedIndex = 0
      } catch (e) {
        console.warn('[CosmoClawInput] 获取人员列表失败:', e)
        if (reset) this.tenantUsers = []
      } finally {
        this.mentionLoading = false
      }
    },
    async selectTenantUser(user) {
      this.selectedTenantUser = user
      this.mentionSelectedIndex = 0
      this.mentionSearchTerm = ''
      await this.fetchUserAgents(user.userId || user.id)
      // CEO演示数字人：不走自动选第一个数字人的逻辑，而是让用户手动选择
      if (this.isCeoDemo && this.userAgents.length > 0) {
        this.mentionStep = 'agents'
        return
      }
      // 直接取第一个数字人，省略下拉选择数字人的步骤
      if (this.userAgents.length > 0) {
        this.selectMentionAgent(this.userAgents[0])
      }
    },
    async fetchUserAgents(userId) {
      this.mentionLoading = true
      try {
        const res = await getUserAgentsApi({ username: userId })
        const data = res.data || res
        if (Array.isArray(data)) {
          this.userAgents = data
        } else if (data.records) {
          this.userAgents = data.records
        } else if (data.list) {
          this.userAgents = data.list
        } else {
          this.userAgents = []
        }
        this.mentionSelectedIndex = 0
      } catch (e) {
        console.warn('[CosmoClawInput] 获取数字人列表失败:', e)
        this.userAgents = []
      } finally {
        this.mentionLoading = false
      }
    },
    backToUserSelection() {
      this.mentionStep = 'users'
      this.userAgents = []
      this.selectedTenantUser = null
      this.mentionSelectedIndex = 0
      this.mentionSearchTerm = ''
    },
    handleMentionScroll(e) {
      const el = e.target
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
        if (this.mentionHasMore && !this.mentionLoading) {
          this.mentionPage++
          this.fetchTenantUsers(false)
        }
      }
    },
    handleUserClick(user) {
      if (user.clawUser === true) {
        this.selectTenantUser(user)
      }
    },
    _debouncedSearch() {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.fetchTenantUsers(true)
      }, 300)
    },
    // 按会话保存输入框内容：切走时暂存，切回时恢复（未发送内容不丢失）
    saveInputDraft(sessionKey) {
      if (!sessionKey) return
      this.$store.commit('cosmoClaw/SET_INPUT_DRAFT', {
        sessionKey,
        text: this.textContent || ''
      })
    },
    restoreInputDraft(sessionKey) {
      const key = sessionKey || ''
      const drafts = this.$store.state.cosmoClaw.inputDrafts || {}
      const text = drafts[key] || ''
      if (this.textContent === text) return
      this.textContent = text
      this.$nextTick(() => this.autoResize())
    },
    setDraftReference(reference) {
      this.draftReference = reference
      this.textContent = reference.prompt || ''
      this.$nextTick(() => {
        if (this.$refs.textarea) {
          this.$refs.textarea.focus()
        }
      })
    },
    setChatInputText(text) {
      if (!text) return
      this.textContent = text
      this.$nextTick(() => {
        if (this.$refs.textarea) {
          this.$refs.textarea.focus()
        }
        this.autoResize()
      })
    },
    clearDraftReference() {
      this.draftReference = null
      this.textContent = ''
    },
    // 点击待发送追问 chip → 在该位置展开追问编辑面板
    handleFollowUpChipClick(item, event) {
      const el = event && event.currentTarget
      const rect = el ? el.getBoundingClientRect() : null
      followUpStore.openEditIsland({
        messageId: item.messageId,
        annotationId: item.annotationId,
        anchorX: rect ? rect.left + rect.width / 2 : window.innerWidth / 2,
        anchorY: rect ? Math.max(36, rect.top - 8) : 80
      })
    },
    // 点击序号 → 定位到对应消息
    handleFollowUpIndexClick(item) {
      const el = document.querySelector(
        `.message-item[data-msg-id="${item.messageId}"]`
      )
      if (el && typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
    followUpChipQuote(item) {
      return truncateForChipTooltip(item.quote, 50) || '引用原文'
    },
    followUpChipNote(item) {
      return truncateForChipTooltip(item.note, 50) || '追问'
    },
    typeWriterEffect(elementId, text) {
      const element = document.getElementById(elementId)
      if (!element) return
      element.innerHTML = ''
      let index = 0
      const speed = 35
      function type() {
        if (index < text.length) {
          element.innerHTML += text.charAt(index)
          index++
          setTimeout(type, speed)
        }
      }
      type()
    },
    appendMentionDemoResponse(agent) {
      const replyId = `mention-reply-${Date.now()}`
      let responseContent = ''
      let keyMetrics = []

      if (agent.key === 'ceo_shu_zi_ren') {
        responseContent =
          'CEO数字人已接收您的指令，正在输出正式回复。我将从战略高度分析企业今日经营状况，形成综合经营简报后回复您。'
        keyMetrics = [
          {
            key: 'gross-margin',
            value: '17.1%',
            label: '毛利率',
            change: '↓1.6pct',
            status: 'warning'
          },
          {
            key: 'revenue',
            value: '8.2亿',
            label: '本月收入',
            change: '+9.5%',
            status: 'good'
          },
          {
            key: 'profit',
            value: '1.4亿',
            label: '本月利润',
            change: '-5.2%',
            status: 'bad'
          },
          { key: 'cost', value: '6.1亿', label: '本月成本', status: 'normal' },
          { key: 'orders', value: '12,847', label: '订单量', status: 'normal' },
          {
            key: 'output',
            value: '28.6万',
            label: '本月产量',
            status: 'normal'
          }
        ]
      } else if (agent.key === 'cfo_shu_zi_ren') {
        responseContent =
          '财务CFO数字人收到。我将从营收达成、毛利、现金流和上市约束四个维度汇总经营结论，形成财务视角简报后回复您。'
        keyMetrics = [
          {
            key: 'revenue',
            value: '8.2亿',
            label: '营收达成',
            change: '+9.5%',
            status: 'good'
          },
          {
            key: 'gross-margin',
            value: '17.1%',
            label: '毛利率',
            change: '↓1.6pct',
            status: 'bad'
          },
          { key: 'cash-flow', value: '正', label: '现金流', status: 'good' },
          {
            key: 'profit',
            value: '1.4亿',
            label: '净利润',
            change: '-5.2%',
            status: 'bad'
          }
        ]
      } else if (agent.key === 'supply_chain_shu_zi_ren') {
        responseContent =
          '供应链CSO数字人已接收指令。我将从采购成本、库存周转、交付准时率和供应商绩效四个维度进行分析，形成供应链优化建议。'
        keyMetrics = [
          {
            key: 'inventory-turn',
            value: '5.2次',
            label: '库存周转',
            change: '+12%',
            status: 'good'
          },
          {
            key: 'delivery-rate',
            value: '94%',
            label: '交付准时率',
            change: '+2%',
            status: 'good'
          },
          {
            key: 'supplier-score',
            value: '88分',
            label: '供应商绩效',
            change: '+5分',
            status: 'good'
          },
          {
            key: 'purchase-cost',
            value: '-3.2%',
            label: '采购成本',
            status: 'good'
          }
        ]
      } else if (agent.key === 'chang_zhang_shu_zi_ren') {
        responseContent =
          '运营COO数字人收到。我将从生产效率、质量合格率、设备稼动率和产能利用率四个维度进行运营分析。'
        keyMetrics = [
          {
            key: 'production-efficiency',
            value: '92%',
            label: '生产效率',
            change: '+3%',
            status: 'good'
          },
          {
            key: 'quality-rate',
            value: '99.2%',
            label: '质量合格率',
            change: '+0.5%',
            status: 'good'
          },
          {
            key: 'equipment-rate',
            value: '87%',
            label: '设备稼动率',
            change: '+2%',
            status: 'good'
          },
          {
            key: 'capacity-rate',
            value: '85%',
            label: '产能利用率',
            status: 'normal'
          }
        ]
      } else if (agent.key === 'sales_cmo_shu_zi_ren') {
        responseContent =
          '销售CMO数字人已接收指令。我将从销售增长、客户结构、市场份额和营销ROI四个维度进行分析。'
        keyMetrics = [
          {
            key: 'sales-growth',
            value: '+12%',
            label: '销售增长',
            status: 'good'
          },
          {
            key: 'customer-concentration',
            value: '64%',
            label: '大客户占比',
            status: 'normal'
          },
          {
            key: 'market-share',
            value: '18%',
            label: '市场份额',
            change: '+2%',
            status: 'good'
          },
          {
            key: 'marketing-roi',
            value: '3.5',
            label: '营销ROI',
            status: 'good'
          }
        ]
      }

      window.followUpRegistry = window.followUpRegistry || {}
      window.followUpRegistry[`mention-${replyId}`] = {
        title: `追问${agent.name}`,
        prompt: `基于${agent.name}的分析，请继续展开说明。`
      }
      const cardHtml = `
        <div id="${replyId}" style="margin-top:2px;display:flex;flex-direction:column;gap:12px;">
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
            <div>
              <div style="font-size:12px;font-weight:600;color:#1f2937;">${
  agent.name
}</div>
              <div style="font-size:10px;color:#8c9bab;">刚刚</div>
            </div>
          </div>
          <div style="margin-left:0;">
            <div style="font-size:12px;font-weight:700;color:#1f2937;margin-bottom:8px;">任务已接收</div>
            <div id="${replyId}-content" style="padding:12px 14px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;font-size:12px;color:#5a6b7e;line-height:1.8;min-height:60px;"></div>
          </div>
          ${
  keyMetrics.length > 0
    ? `
          <div id="${replyId}-metrics" style="margin-left:0;display:flex;flex-wrap:wrap;gap:8px;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            ${keyMetrics
    .map(
      (metric) => `
              <div style="padding:10px 14px;border-radius:8px;background:#fff;border:1px solid #e8ecf0;min-width:100px;">
                <div style="font-size:18px;font-weight:700;color:${
  metric.status === 'good'
    ? '#10b981'
    : metric.status === 'bad'
      ? '#ef4444'
      : metric.status === 'warning'
        ? '#f59e0b'
        : '#1f2937'
};">${metric.value}</div>
                <div style="font-size:10px;color:#8c9bab;margin-top:2px;">${
  metric.label
}</div>
                ${
  metric.change
    ? `<div style="font-size:10px;color:${
      metric.change.startsWith('+') ? '#10b981' : '#ef4444'
    };">${metric.change}</div>`
    : ''
}
              </div>
            `
    )
    .join('')}
          </div>
          `
    : ''
}
          <div id="${replyId}-followup" style="margin-left:0;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <span style="font-size:11px;color:#4A5FF3;cursor:pointer;text-decoration:underline;" onclick="window.triggerCeoFollowUp('mention-${replyId}')">追问</span>
          </div>
        </div>
      `

      this.$store.commit('cosmoClaw/ADD_MESSAGE', {
        id: `local-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        type: 'assistant',
        content: cardHtml,
        timestamp: Date.now(),
        isHistory: false,
        richHtml: true
      })

      setTimeout(() => {
        this.typeWriterEffect(`${replyId}-content`, responseContent)
      }, 200)
      if (keyMetrics.length > 0) {
        setTimeout(() => {
          const el = document.getElementById(`${replyId}-metrics`)
          if (el) {
            el.style.opacity = '1'
            el.style.transform = 'translateY(0)'
          }
        }, 800)
      }
      setTimeout(
        () => {
          const el = document.getElementById(`${replyId}-followup`)
          if (el) {
            el.style.opacity = '1'
            el.style.transform = 'translateY(0)'
          }
        },
        keyMetrics.length > 0 ? 1300 : 800
      )
    },
    async handlePaste(e) {
      const items = e.clipboardData?.items
      if (!items) return

      // 检查是否有图片
      for (const item of items) {
        if (item.type.startsWith('image/')) {
          e.preventDefault()
          const file = item.getAsFile()
          if (file) {
            await this.uploadSingleFile(file)
          }
          return
        }
      }

      // 检查粘贴的文本是否是文件 URL
      const text = e.clipboardData.getData('text/plain')
      if (text) {
        const trimmed = text.trim()
        const urlPattern = /^https?:\/\/[^\s]+$/i
        if (urlPattern.test(trimmed)) {
          const urlPath = trimmed.split('?')[0].split('#')[0]
          const lastSegment = urlPath.split('/').pop() || ''
          const hasFileExt = /\.[a-z0-9]{2,5}$/i.test(lastSegment)
          if (hasFileExt) {
            e.preventDefault()
            this.uploadedFiles.push({
              id: Date.now() + '-' + Math.random().toString(36).slice(2),
              name: lastSegment,
              url: trimmed,
              size: 0,
              type: '',
              progress: 100,
              isUploading: false,
              _hovered: false
            })
            return
          }
        }
      }
    },
    extractMentionAgentFromText(text) {
      const rawText = String(text || '')
      // 先匹配静态 mentionAgents（旧 demo 格式：@label/@alias）
      let matched = null
      this.mentionAgents.forEach((item) => {
        const candidates = [item.label, item.shortName]
          .concat(item.aliases || [])
          .filter(Boolean)
        candidates.forEach((candidate) => {
          const token = '@' + candidate
          const index = rawText.indexOf(token)
          if (index === -1) return
          if (
            !matched ||
            index < matched.index ||
            (index === matched.index && token.length > matched.token.length)
          ) {
            matched = {
              item,
              index,
              token,
              isAgentId: false
            }
          }
        })
      })

      // 如果没匹配到静态 agents，尝试匹配 @agent-id（数字 ID 或任意非空 token）
      if (!matched) {
        const atRegex = /@(\S+)/g
        let match
        while ((match = atRegex.exec(rawText)) !== null) {
          if (!matched || match.index < matched.index) {
            matched = {
              item: { key: match[1], label: match[1], id: match[1] },
              index: match.index,
              token: match[0],
              isAgentId: true
            }
          }
        }
      }

      return matched
    },
    stripMentionAgentFromText(text, mentionMatch) {
      const rawText = String(text || '')
      if (!mentionMatch || !mentionMatch.token) {
        return rawText.trim()
      }
      return (
        rawText.slice(0, mentionMatch.index) +
        rawText.slice(mentionMatch.index + mentionMatch.token.length)
      )
        .replace(/\s{2,}/g, ' ')
        .trim()
    },
    detectCfoScenario(text) {
      const normalized = String(text || '').trim()
      if (!normalized) return null
      if (
        /毛利率下滑诊断|分析毛利率|毛利率.*下滑|下滑.*毛利率/.test(normalized)
      ) {
        return 'margin'
      }
      if (normalized.includes('毛利率') || normalized.includes('下滑')) {
        return 'margin'
      }
      if (/采购|降本/.test(normalized)) return 'cost'
      if (/简报|例会/.test(normalized)) return 'report'
      if (/现金|压力/.test(normalized)) return 'cash'
      return null
    },
    isCfoMarginTaskText(text) {
      return /毛利率下滑诊断|分析毛利率|毛利率异常|毛利异常|毛利率|毛利分析|下滑|PVMC/i.test(
        String(text || '')
      )
    },
    dispatchCfoScenario(scenario, userText, displayText) {
      const content = String(userText || '').trim()
      if (!content || !scenario) return false
      const finalContent = displayText || content
      this.$store.commit('cosmoClaw/ADD_MESSAGE', {
        id: `local-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        type: 'user',
        content: finalContent,
        timestamp: Date.now(),
        isHistory: false,
        richHtml: !!displayText
      })
      this.textContent = ''
      this.uploadedFiles = []
      this.draftReference = null
      this.selectedMention = null
      this.$nextTick(() => this.autoResize())
      setTimeout(() => {
        if (typeof window.triggerCfoScenario === 'function') {
          window.triggerCfoScenario(scenario, content)
        }
      }, 400)
      return true
    },
    handleCfoQuickChip(chip) {
      if (!chip || !chip.scenario) return
      this.dispatchCfoScenario(chip.scenario, chip.label)
    },
    tryHandleCfoScenario(content, mentionMatch, displayContent) {
      const taskText =
        mentionMatch && mentionMatch.item
          ? this.stripMentionAgentFromText(content, mentionMatch)
          : content
      const isCfoMention =
        mentionMatch && mentionMatch.item && mentionMatch.item.key === 'cfo'
      if (!this.isCfoAgent && !isCfoMention) return false
      const scenario = this.detectCfoScenario(taskText || content)
      if (!scenario) {
        if (isCfoMention && this.isCfoMarginTaskText(taskText)) {
          return this.dispatchCfoScenario('margin', content, displayContent)
        }
        return false
      }
      return this.dispatchCfoScenario(scenario, content, displayContent)
    },
    buildMentionAgentReply(item, taskText) {
      const cleanTask = String(taskText || '').trim()
      const hasKeyword = (keywords) =>
        keywords.some((keyword) => cleanTask.indexOf(keyword) !== -1)

      if (!cleanTask) {
        const emptyReplies = {
          cfo: '财务CFO数字人收到。我将从营收达成、毛利、现金流和上市约束四个维度汇总经营结论，形成财务视角简报后回复您。',
          cso: '供应链CSO数字人收到。我会先同步供应链、物流通道和备料风险，给您一版供应保障与风险缓释建议。',
          coo: '运营COO数字人收到。我将拉通产能、排产、交付和工厂协同数据，快速回传运营侧判断。',
          cmo: '销售CMO数字人收到。我会先看订单、客户、渠道和市场节奏，再给您销售经营建议。',
          cto: '技术CTO数字人收到。我将从技术方案、研发排期和系统支撑能力三个维度整理回复。'
        }
        return emptyReplies[item.key] || '收到，我来处理。'
      }

      if (item.key === 'cfo') {
        if (
          hasKeyword(['营收', '收入', '回款', '现金流', '毛利', '利润', '上市'])
        ) {
          return (
            '财务CFO数字人已接单。围绕"' +
            cleanTask +
            '"，我会先校准营收达成、毛利波动、回款节奏和现金流安全垫，并同步判断是否触碰上市冲刺约束。\n\n第一版建议会优先输出异常项、资金缺口和可执行的财务动作。'
          )
        }
        return (
          '财务CFO数字人收到。这个任务我会从财务测算和经营结果约束两条线并行分析，重点回答"' +
          cleanTask +
          '"对利润、现金流和经营节奏的影响。'
        )
      }

      if (item.key === 'cso') {
        if (hasKeyword(['供应链', '采购', '库存', '交付', '成本', 'BOM'])) {
          return (
            '供应链CSO数字人已接单。围绕"' +
            cleanTask +
            '"，我会先梳理供应链健康度、关键物料库存水位、交付履约率和成本波动情况，并给出风险缓释建议。'
          )
        }
        return (
          '供应链CSO数字人收到。我将从供应链统筹、风险预警和替代方案三个维度分析"' +
          cleanTask +
          '"，确保供应安全和成本可控。'
        )
      }

      if (item.key === 'coo') {
        if (hasKeyword(['产能', '排产', '交付', '效率', '质量', '设备'])) {
          return (
            '运营COO数字人已接单。围绕"' +
            cleanTask +
            '"，我会拉通产能利用率、排产计划、交付准时率和质量合格率，快速定位瓶颈并给出优化建议。'
          )
        }
        return (
          '运营COO数字人收到。我将从产能调度、交付协同和排产优化三个维度分析"' +
          cleanTask +
          '"，提升运营效率和交付能力。'
        )
      }

      if (item.key === 'cmo') {
        if (hasKeyword(['销售', '订单', '客户', '市场', '渠道', '增长'])) {
          return (
            '销售CMO数字人已接单。围绕"' +
            cleanTask +
            '"，我会先看订单趋势、客户结构、渠道表现和市场份额，再给出销售策略建议。'
          )
        }
        return (
          '销售CMO数字人收到。我将从销售策略、市场节奏和客户经营三个维度分析"' +
          cleanTask +
          '"，推动销售增长和客户价值提升。'
        )
      }

      if (item.key === 'cto') {
        if (hasKeyword(['技术', '研发', '系统', '方案', '排期', '能力'])) {
          return (
            '技术CTO数字人已接单。围绕"' +
            cleanTask +
            '"，我会从技术方案可行性、研发排期和系统支撑能力三个维度进行分析评估。'
          )
        }
        return (
          '技术CTO数字人收到。我将从技术方案、研发排期和系统能力三个维度分析"' +
          cleanTask +
          '"，确保技术支撑和创新能力。'
        )
      }

      return item.label + '收到，我来处理"' + cleanTask + '"这个任务。'
    },
    async handleSend() {
      // Stop microphone input before sending the message.
      this.cancelRecording()
      if (!this.canSend) return
      if (this.isStopping) return

      // 正在回答中：不打断当前回答，把本次输入放入待发送队列，回答结束后依次发送
      if (this.isStreaming) {
        // 输入区为空、仅有待发送追问时不入队，避免产生空消息；
        // 追问保持 pending，随本轮结束后的下一条消息一起发送
        const hasInput =
          this.textContent.trim().length > 0 ||
          this.uploadedFiles.length > 0 ||
          !!this.selectedMention
        if (hasInput) this.enqueueCurrentInput()
        return
      }

      // 可选拦截钩子：chat-dropdown 等场景发送时跳转到对应数字人的对话页发送
      if (typeof this.beforeSend === 'function') {
        const handled = this.beforeSend({
          content: this.textContent,
          files: this.uploadedFiles ? this.uploadedFiles.slice() : [],
          mention: this.selectedMention
        })
        if (handled) {
          this.textContent = ''
          this.uploadedFiles = []
          this.selectedMention = null
          this.$nextTick(() => this.autoResize())
          return
        }
      }

      // Demo 模式下发送真实消息：退出 demo 模式，保留 demo 消息
      if (this.localDemoMode) {
        this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)
      }

      // @数字人 chip 处理：将选中 mention 转换为原始 @agent-xxx 格式用于解析和发送，
      // 同时生成展示友好的 HTML 内容用于消息气泡显示
      const mentionChip = this.selectedMention
      let _displayContent = ''
      if (mentionChip) {
        const originalText = this.textContent
        const mentionRaw = `@agent-${mentionChip.agentId} `
        _displayContent =
          `<span class="mention-chip-inline">@${mentionChip.displayName}</span> ` +
          originalText
        this.textContent = mentionRaw + originalText // 拼回原始 agent-id 用于后续解析
      }

      const urlPattern = /https?:\/\/[^\s]+/gi
      const urls = this.textContent.match(urlPattern) || []
      const urlFiles = []
      const fileUrls = []

      urls.forEach((url) => {
        const urlPath = url.split('?')[0].split('#')[0]
        const lastSegment = urlPath.split('/').pop() || ''
        const hasFileExt = /\.[a-z0-9]{2,5}$/i.test(lastSegment)

        if (hasFileExt) {
          fileUrls.push(url)
          urlFiles.push({
            id: Date.now() + '-' + Math.random().toString(36).slice(2),
            name: lastSegment,
            url,
            size: 0,
            type: '',
            progress: 100,
            isUploading: false,
            _hovered: false
          })
        }
      })

      let cleanContent = this.textContent
      fileUrls.forEach((url) => {
        cleanContent = cleanContent.replace(url, '')
        if (mentionChip) {
          _displayContent = _displayContent.replace(url, '')
        }
      })
      cleanContent = cleanContent.trim()
      if (mentionChip) {
        _displayContent = _displayContent.trim()
      }

      const allFiles = [...this.uploadedFiles, ...urlFiles]

      const hasDraftReference = !!this.draftReference

      // 待发送追问：按文本协议拼进用户消息（历史消息由渲染侧反解析还原为卡片）
      const pendingFollowUps = followUpStore.getPendingFollowUps()
      const followUpSection = formatFollowUpSection(pendingFollowUps, {
        includeTopSeparator: cleanContent.length > 0
      })
      const finalContent = followUpSection
        ? normalizeFollowUpsMarkdown(
          cleanContent
            ? `${cleanContent}\n\n${followUpSection}`
            : followUpSection
        )
        : cleanContent
      // 有追问时放弃 richHtml 展示内容，避免 HTML 与 Markdown 追问段混排
      const displayContentForSend =
        mentionChip && pendingFollowUps.length === 0 ? _displayContent : undefined
      // 发送后清除已追问的注解（高亮与序号角标一并消失）
      const dispatchSendMessage = (payload) => {
        this.$store.dispatch('cosmoClaw/sendMessage', payload)
        if (pendingFollowUps.length > 0) {
          followUpStore.clearSent(pendingFollowUps)
          followUpStore.closeIsland()
        }
      }

      const mentionMatch = this.extractMentionAgentFromText(cleanContent)
      if (mentionMatch && mentionMatch.item) {
        const item = mentionMatch.item
        const taskText = this.stripMentionAgentFromText(
          cleanContent,
          mentionMatch
        )

        // 检查 demo 关键词（CFO/CSO 场景）
        if (
          this.tryHandleCfoScenario(
            cleanContent,
            mentionMatch,
            mentionChip ? _displayContent : undefined
          )
        ) {
          return
        }

        // 如果是真实数字人 agent-id（非静态 demo agent）
        if (mentionMatch.isAgentId) {
          // 仅"分析毛利率"和"制定关差方案"触发 demo，其余全部走真实对话
          if (/分析毛利率/.test(taskText)) {
            this.dispatchCfoScenario(
              'margin',
              cleanContent,
              mentionChip ? _displayContent : undefined
            )
            return
          }
          if (/制定关差方案/.test(taskText)) {
            const userContent = mentionChip ? _displayContent : cleanContent
            this.$store.commit('cosmoClaw/ADD_MESSAGE', {
              id: `local-${Date.now()}-${Math.random().toString(36).slice(2)}`,
              type: 'user',
              content: userContent,
              timestamp: Date.now(),
              isHistory: false,
              richHtml: !!mentionChip
            })
            this.selectedMention = null
            setTimeout(() => {
              if (typeof window.csoStepBomDiagnosis === 'function') {
                window.csoStepBomDiagnosis()
              }
            }, 400)
            this.textContent = ''
            this.uploadedFiles = []
            this.$nextTick(() => this.autoResize())
            return
          }
          // 非 demo：直接发送给大模型（sendMessage 内部会 ADD_MESSAGE，这里不重复提交）
          this.textContent = ''
          this.uploadedFiles = []
          this.draftReference = null
          this.selectedMention = null
          this.$nextTick(() => this.autoResize())
          if (!this.currentSessionKey) {
            this.$store
              .dispatch('cosmoClaw/createNewSession', {
                agentName: this.$store.state.cosmoClaw.currentAgentName,
                agentId: this.$store.state.cosmoClaw.currentAgentId || ''
              })
              .then((sessionKey) => {
                setTimeout(() => {
                  dispatchSendMessage({
                    content: finalContent,
                    displayContent: displayContentForSend,
                    sessionKey,
                    files: this.getFilesForSend(allFiles)
                  })
                }, 500)
              })
          } else {
            dispatchSendMessage({
              content: finalContent,
              displayContent: displayContentForSend,
              files: this.getFilesForSend(allFiles)
            })
          }
          return
        }

        // 静态 demo agent：走旧的 demo 回复逻辑
        const replyText = this.buildMentionAgentReply(item, taskText)

        const userContent = mentionChip ? _displayContent : cleanContent
        this.$store.commit('cosmoClaw/ADD_MESSAGE', {
          id: `local-${Date.now()}-${Math.random().toString(36).slice(2)}`,
          type: 'user',
          content: userContent,
          timestamp: Date.now(),
          isHistory: false,
          richHtml: !!mentionChip
        })

        const replyId = `mention-assistant-reply-${Date.now()}`
        const isCsoBomTask =
          item.key === 'cso' &&
          /关差|BOM|成本上升|涨价|供应链|制定方案/i.test(taskText)

        if (isCsoBomTask) {
          setTimeout(() => {
            if (typeof window.csoStepBomDiagnosis === 'function') {
              window.csoStepBomDiagnosis()
            }
          }, 400)
          this.textContent = ''
          this.uploadedFiles = []
          this.selectedMention = null
          this.$nextTick(() => this.autoResize())
          return
        }

        const cardHtml = `
          <div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px 16px 14px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;">
            <div style="min-width:0;width:100%;box-sizing:border-box;">
              <div style="font-size:15px;font-weight:700;color:#1f2937;">任务已接收</div>
              <div style="margin-top:8px;font-size:13px;line-height:1.7;color:#5a6b7e;width:100%;">对应数字人已接收您的指令，正在输出正式回复。</div>
              <div id="${replyId}" style="margin-top:12px;font-size:13px;color:#475569;line-height:1.9;white-space:pre-line;min-height:88px;"></div>
              <div id="${replyId}-followup" style="margin-top:12px;opacity:0;transform:translateY(8px);transition:all .28s ease;">
                <span style="font-size:12px;color:#4A5FF3;cursor:pointer;text-decoration:underline;" onclick="window.triggerCeoFollowUp('${replyId}')">追问当前数字人回复</span>
              </div>
            </div>
          </div>
        `

        window.followUpRegistry = window.followUpRegistry || {}
        window.followUpRegistry[replyId] = {
          title: '追问当前数字人回复',
          prompt: `基于${item.label}的分析，请继续展开说明。`
        }

        this.$store.commit('cosmoClaw/ADD_MESSAGE', {
          id: `local-${Date.now()}-${Math.random().toString(36).slice(2)}`,
          type: 'assistant',
          content: cardHtml,
          timestamp: Date.now(),
          isHistory: false,
          richHtml: true,
          digitalHuman: item.key.toUpperCase()
        })

        setTimeout(() => {
          this.typeWriterEffect(replyId, replyText)
        }, 560)

        setTimeout(() => {
          const el = document.getElementById(`${replyId}-followup`)
          if (el) {
            el.style.opacity = '1'
            el.style.transform = 'translateY(0)'
          }
        }, 2000)

        this.textContent = ''
        this.uploadedFiles = []
        this.selectedMention = null
        this.$nextTick(() => this.autoResize())
        return
      }

      if (hasDraftReference) {
        const userContent = mentionChip ? _displayContent : cleanContent
        this.$store.commit('cosmoClaw/ADD_MESSAGE', {
          id: `local-${Date.now()}-${Math.random().toString(36).slice(2)}`,
          type: 'user',
          content: userContent,
          timestamp: Date.now(),
          isHistory: false,
          richHtml: !!mentionChip
        })

        const replyId = `follow-up-reply-${Date.now()}`
        const followUpContent = `
          <div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;">
            <div style="min-width:0;width:100%;box-sizing:border-box;">
              <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
                <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#4A5FF3,#6B7FFF);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">C</div>
                <div>
                  <div style="font-size:12px;font-weight:600;color:#1f2937;">CEO数字人</div>
                  <div style="font-size:10px;color:#8c9bab;">刚刚</div>
                </div>
              </div>
              <div style="font-size:15px;font-weight:700;color:#1f2937;margin-bottom:8px;">追问分析</div>
              <div style="margin-top:8px;font-size:13px;line-height:1.7;color:#5a6b7e;width:100%;">
                基于刚才的分析，当前最需要优先处理的风险是毛利率异常下降问题。建议由财务部门牵头，联合销售和生产部门共同分析低价订单结构，制定毛利率修复方案，并在本周五前完成初步方案讨论。
              </div>
              <div id="${replyId}-followup" style="margin-top:12px;opacity:0;transform:translateY(8px);transition:all .28s ease;">
                <span style="font-size:12px;color:#4A5FF3;cursor:pointer;text-decoration:underline;" onclick="window.triggerCeoFollowUp('${replyId}')">追问当前数字人回复</span>
              </div>
            </div>
          </div>
        `
        this.$store.commit('cosmoClaw/ADD_MESSAGE', {
          id: `local-${Date.now()}-${Math.random().toString(36).slice(2)}`,
          type: 'assistant',
          content: followUpContent,
          timestamp: Date.now(),
          isHistory: false,
          richHtml: true
        })

        window.followUpRegistry = window.followUpRegistry || {}
        window.followUpRegistry[replyId] = {
          title: '追问当前结论',
          summary: '基于刚才的追问分析，继续展开更多细节。',
          prompt: '基于刚才的分析，请继续展开更多细节。'
        }

        setTimeout(() => {
          const el = document.getElementById(`${replyId}-followup`)
          if (el) {
            el.style.opacity = '1'
            el.style.transform = 'translateY(0)'
          }
        }, 1500)

        this.textContent = ''
        this.uploadedFiles = []
        this.draftReference = null
        this.selectedMention = null
        this.$nextTick(() => this.autoResize())
        return
      }

      if (
        this.tryHandleCfoScenario(
          cleanContent,
          null,
          mentionChip ? _displayContent : undefined
        )
      ) {
        return
      }

      if (!this.currentSessionKey) {
        this.$store
          .dispatch('cosmoClaw/createNewSession', {
            agentName: this.$store.state.cosmoClaw.currentAgentName,
            agentId: this.$store.state.cosmoClaw.currentAgentId || ''
          })
          .then((sessionKey) => {
            setTimeout(() => {
              dispatchSendMessage({
                content: finalContent,
                sessionKey,
                files: this.getFilesForSend(allFiles)
              })
            }, 500)
          })
      } else {
        dispatchSendMessage({
          content: finalContent,
          files: this.getFilesForSend(allFiles)
        })
      }
      this.textContent = ''
      this.uploadedFiles = []
      this.selectedMention = null
      this.$nextTick(() => this.autoResize())
    },
    async handleStop() {
      if (this.isStopping) return
      this.isStopping = true
      this.cancelRecording()
      const store = this.$store
      const { currentAgentId, currentSessionKey, currentRunId } = store.state.cosmoClaw
      try {
        // 先本地收尾，立即停止气泡的流式态（不依赖服务端回包速度）
        store.dispatch('cosmoClaw/finishStreamingMessage')
        // 只中止本轮 run：不删除、不新建会话，原会话与已产出的内容继续保留
        await store
          .dispatch('cosmoClaw/abortConversation', {
            agentId: currentAgentId,
            sessionKey: currentSessionKey,
            runId: currentRunId
          })
          .catch((e) => {
            console.warn('[CosmoClawInput] 中止对话失败:', e)
          })
      } finally {
        // 兜底清理中止标记，避免原会话后续提问的 assistant/tool/thinking 事件被 isAborting 拦截
        store.commit('cosmoClaw/SET_IS_ABORTING', false)
        this.isStopping = false
        this.$nextTick(() => {
          this.autoResize()
          if (this.$refs.textarea) this.$refs.textarea.focus()
        })
      }
    },
    // handleClearSession() {
    //   if (this.isStreaming || !this.isHandshaked) return
    //   this.$store.dispatch('cosmoClaw/createNewSession', { agentName: this.currentAgentName })
    // },

    // ===== 待发送队列 =====
    // 把当前输入区内容快照入队，并清空输入区（回答结束后再按序发送）
    enqueueCurrentInput() {
      if (!this.canSend) return
      this.pendingQueue.push({
        id: `pending-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        textContent: this.textContent,
        uploadedFiles: this.uploadedFiles ? this.uploadedFiles.slice() : [],
        selectedMention: this.selectedMention,
        draftReference: this.draftReference,
        sessionKey: this.currentSessionKey
      })
      this.textContent = ''
      this.uploadedFiles = []
      this.selectedMention = null
      this.draftReference = null
      this.$nextTick(() => {
        this.autoResize()
        if (this.$refs.textarea) this.$refs.textarea.focus()
      })
    },
    removeQueuedMessage(id) {
      this.pendingQueue = this.pendingQueue.filter((item) => item.id !== id)
    },
    // 插队：中止当前正在回答的问题，立即改为回答该问题（其余队列项保持原顺序）
    async jumpQueuedMessage(id) {
      if (this.isFlushingQueue || this.isStopping) return
      if (this.isDisabled) return
      const item = this.pendingQueue.find((it) => it.id === id)
      if (!item) return
      // 先移出队列，避免中止后 watcher 抢先发送排在前面的问题
      this.pendingQueue = this.pendingQueue.filter((it) => it.id !== id)
      this.clearFlushTimer()
      this.isFlushingQueue = true
      try {
        // 只中止当前回答（会话保留、历史消息继续可见），随后立即回答该问题
        if (this.isStreaming) await this.handleStop()
        await this.sendQueuedItem(item)
      } finally {
        this.isFlushingQueue = false
        // 未进入流式（本地/demo 回复等分支）：继续处理队列中的下一条
        if (!this.isStreaming) this.scheduleFlush(300)
      }
    },
    // 记录/还原输入区状态，用于发送队列项期间暂存用户正在编辑的草稿
    captureInputState() {
      return {
        textContent: this.textContent,
        uploadedFiles: this.uploadedFiles ? this.uploadedFiles.slice() : [],
        selectedMention: this.selectedMention,
        draftReference: this.draftReference
      }
    },
    applyInputState(state) {
      if (!state) return
      this.textContent = state.textContent || ''
      this.uploadedFiles = state.uploadedFiles ? state.uploadedFiles.slice() : []
      this.selectedMention = state.selectedMention || null
      this.draftReference = state.draftReference || null
    },
    // 发送某个队列项：写回输入区后复用完整发送链路，发送结束还原用户草稿
    async sendQueuedItem(item) {
      if (!item) return
      const draft = this.captureInputState()
      this.applyInputState(item)
      try {
        await this.$nextTick()
        this.autoResize()
        // 复用完整发送链路：mention/@数字人、引用、附件、URL 解析
        await this.handleSend()
      } catch (e) {
        console.warn('[CosmoClawInput] 发送队列消息失败:', e)
      } finally {
        if (
          !this.textContent &&
          this.uploadedFiles.length === 0 &&
          !this.selectedMention
        ) {
          this.applyInputState(draft)
        }
        this.$nextTick(() => this.autoResize())
      }
    },
    clearFlushTimer() {
      if (this.flushTimer) {
        clearTimeout(this.flushTimer)
        this.flushTimer = null
      }
    },
    scheduleFlush(delay = 400) {
      this.clearFlushTimer()
      if (this.queuedMessages.length === 0) return
      this.flushTimer = setTimeout(() => {
        this.flushTimer = null
        this.maybeFlushQueue()
      }, delay)
    },
    // 空闲时发送队列中的下一条
    async maybeFlushQueue() {
      if (this.isFlushingQueue || this.isStreaming || this.isStopping) return
      if (this.isDisabled) return
      const next = this.queuedMessages[0]
      if (!next) return
      this.isFlushingQueue = true
      this.pendingQueue = this.pendingQueue.filter((item) => item.id !== next.id)
      try {
        await this.sendQueuedItem(next)
      } finally {
        this.isFlushingQueue = false
        // 未进入流式（本地/demo 回复等分支）：继续处理下一条
        if (!this.isStreaming) {
          this.scheduleFlush(300)
        }
      }
    },
    handleModelChange(val) {
      this.$store.dispatch('cosmoClaw/updateModel', { modelId: val })
    },
    handleKnowledgeBaseChange(val) {
      this.$store.commit('cosmoClaw/SET_KNOWLEDGE_SWITCH', {
        sessionKey: this.currentSessionKey,
        value: val ? 1 : 0
      })
    },
    autoResize() {
      const ta = this.$refs.textarea
      if (!ta) return
      ta.style.height = 'auto'
      // 输入框整体上限 214px = textarea 154 + 工具栏 32 + 上下内边距 28
      const maxHeight = 154
      ta.style.height = Math.min(ta.scrollHeight, maxHeight) + 'px'
    },

    // File upload
    // 附件二级菜单：切换显示（方向自适应：按钮下方空间不足时向上弹出）
    toggleAttachMenu() {
      if (this.isUploading) return
      if (!this.showAttachMenu) {
        const wrap = this.$refs.attachMenuWrap
        if (wrap) {
          const rect = wrap.getBoundingClientRect()
          const spaceBelow = window.innerHeight - rect.bottom
          this.attachMenuUp = spaceBelow < 130
        }
      }
      this.showAttachMenu = !this.showAttachMenu
    },
    // 附件二级菜单：选择类型后拉起文件选择器
    // doc → 任意文件；image → 仅图片
    handleAttachMenuPick(type) {
      this.showAttachMenu = false
      const input = this.$refs.fileInput
      if (!input) return
      input.setAttribute('accept', type === 'image' ? 'image/*' : '*/*')
      input.click()
    },
    // 点击组件外部时关闭附件菜单
    handleClickOutsideAttachMenu(e) {
      if (!this.showAttachMenu) return
      const wrap = this.$refs.attachMenuWrap
      if (wrap && !wrap.contains(e.target)) {
        this.showAttachMenu = false
      }
    },
    handleFileSelect(e) {
      const files = e.target.files
      if (!files || files.length === 0) return
      this.uploadFiles(Array.from(files))
      e.target.value = ''
    },
    handleDrop(e) {
      this.isDragOver = false
      const files = e.dataTransfer.files
      if (!files || files.length === 0) return
      this.uploadFiles(Array.from(files))
    },
    async uploadFiles(files) {
      for (const file of files) {
        if (file.size > 200 * 1024 * 1024) {
          this.$message.error(
            this.$t('workbench.fileSizeExceed', { name: file.name })
          )
          continue
        }
        await this.uploadSingleFile(file)
      }
    },
    async uploadSingleFile(file) {
      const fileId = Date.now() + '-' + Math.random().toString(36).slice(2)
      const tempFile = {
        id: fileId,
        name: file.name,
        url: '',
        size: file.size,
        type: file.type,
        progress: 0,
        isUploading: true,
        _hovered: false
      }
      this.uploadedFiles.push(tempFile)

      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await requestUploadFile(formData, (percent) => {
          const idx = this.uploadedFiles.findIndex((f) => f.id === fileId)
          if (idx !== -1) this.$set(this.uploadedFiles[idx], 'progress', percent)
        })
        const idx = this.uploadedFiles.findIndex((f) => f.id === fileId)
        if (idx !== -1) {
          this.$set(this.uploadedFiles[idx], 'isUploading', false)
          this.$set(this.uploadedFiles[idx], 'progress', 100)
          // 根据项目上传接口实际响应格式提取文件访问路径
          const fileUrl =
            res.message ||
            res.data?.data?.url ||
            res.data?.url ||
            res.data?.path ||
            res.data?.data?.path ||
            res.url ||
            ''
          this.$set(this.uploadedFiles[idx], 'url', fileUrl)
        }
        this.$message.success(
          this.$t('workbench.uploadSuccess', { name: file.name })
        )
      } catch (e) {
        const idx = this.uploadedFiles.findIndex((f) => f.id === fileId)
        if (idx !== -1) {
          this.uploadedFiles.splice(idx, 1)
        }
        this.$message.error(
          this.$t('workbench.uploadFailed', { name: file.name })
        )
      }
    },
    removeFile(id) {
      this.uploadedFiles = this.uploadedFiles.filter((f) => f.id !== id)
    },
    getFilesForSend(fileList) {
      const list = fileList || this.uploadedFiles
      return list
        .filter((f) => !f.isUploading && f.url)
        .map((f) => ({ name: f.name, url: f.url, type: f.type }))
    },

    isImageFile(name) {
      const ext = this.getFileExtension(name).toLowerCase()
      return [
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'svg',
        'webp',
        'ico'
      ].includes(ext)
    },
    getFileExtension(name) {
      if (!name) return ''
      const parts = name.split('.')
      return parts.length > 1 ? parts.pop() : ''
    },
    getFileTypeColor(name) {
      const ext = this.getFileExtension(name).toLowerCase()
      const colorMap = {
        pdf: '#E53935',
        doc: '#1E88E5',
        docx: '#1E88E5',
        xls: '#43A047',
        xlsx: '#43A047',
        csv: '#26A69A',
        ppt: '#FB8C00',
        pptx: '#FB8C00',
        js: '#7E57C2',
        ts: '#7E57C2',
        py: '#7E57C2',
        java: '#7E57C2',
        txt: '#78909C',
        md: '#78909C',
        zip: '#8D6E63',
        rar: '#8D6E63',
        '7z': '#8D6E63',
        mp4: '#AB47BC',
        avi: '#AB47BC',
        mov: '#AB47BC',
        mp3: '#5C6BC0',
        wav: '#5C6BC0',
        jpg: '#EC407A',
        jpeg: '#EC407A',
        png: '#EC407A',
        gif: '#EC407A',
        svg: '#EC407A'
      }
      return colorMap[ext] || '#90A4AE'
    },
    getFileTypeLabel(name) {
      const ext = this.getFileExtension(name).toLowerCase()
      const labelMap = {
        pdf: 'PDF',
        doc: 'DOC',
        docx: 'DOC',
        xls: 'XLS',
        xlsx: 'XLS',
        csv: 'CSV',
        ppt: 'PPT',
        pptx: 'PPT',
        js: 'CODE',
        ts: 'CODE',
        py: 'CODE',
        java: 'CODE',
        txt: 'TXT',
        md: 'TXT',
        zip: 'ZIP',
        rar: 'RAR',
        '7z': '7Z',
        mp4: 'MP4',
        avi: 'AVI',
        mov: 'MOV',
        mp3: 'MP3',
        wav: 'WAV'
      }
      return labelMap[ext] || ext.toUpperCase().slice(0, 4) || 'FILE'
    },
    formatFileSize(size) {
      if (!size) return ''
      if (size < 1024) return size + ' B'
      if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB'
      return (size / (1024 * 1024)).toFixed(1) + ' MB'
    },

    // Voice recording
    async handleRecord() {
      if (this.isStreaming) return
      if (this.isRecording) {
        // Manual second click: keep the final ASR frame, then stop.
        this.stopRecording()
        return
      }
      if (this.asrInstance) {
        // Do not create a second microphone connection while stopping.
        this.cancelRecording()
        return
      }

      const existingText = this.textContent || ''
      const requestId = ++this.recordingRequestId
      const asrInstance = new VolcengineASR({
        onResult: (text) => {
          if (
            this.recordingRequestId !== requestId ||
            this.asrInstance !== asrInstance
          ) {
            return
          }
          this.textContent = existingText + text
        },
        onError: (err) => {
          if (
            this.recordingRequestId !== requestId ||
            this.asrInstance !== asrInstance
          ) {
            return
          }
          console.error('[VoiceInput] ASR error:', err)
          if (err && err.name === 'NotAllowedError') {
            this.$message.error(this.$t('workbench.micDenied'))
          } else if (err && err.name === 'NotFoundError') {
            this.$message.error(this.$t('workbench.micNotFound'))
          } else {
            this.$message.error(this.$t('workbench.micError'))
          }
          this.cancelRecording()
        },
        onStateChange: (state) => {
          if (
            this.recordingRequestId !== requestId ||
            this.asrInstance !== asrInstance
          ) {
            return
          }
          if (state === 'recording') {
            this.isRecording = true
            this.$message.info(this.$t('workbench.startRecording'))
          } else if (state === 'stopped') {
            this.isRecording = false
            this.asrInstance = null
          }
        }
      })
      this.asrInstance = asrInstance

      // A cancel can happen while getUserMedia or WebSocket setup is pending.
      // Re-check after start so a cancelled instance cannot keep the microphone open.
      Promise.resolve(asrInstance.start()).then(() => {
        if (
          this.recordingRequestId !== requestId ||
          this.asrInstance !== asrInstance
        ) {
          if (asrInstance.isRunning) asrInstance.abort()
        }
      })
    },

    stopRecording() {
      const asrInstance = this.asrInstance
      if (!asrInstance) {
        this.isRecording = false
        return
      }
      if (!asrInstance.isRunning) {
        this.cancelRecording()
        return
      }
      this.isRecording = false
      asrInstance.stop()
    },

    // Context switches abort immediately and ignore late ASR callbacks.
    cancelRecording() {
      this.recordingRequestId += 1
      const asrInstance = this.asrInstance
      this.asrInstance = null
      this.isRecording = false
      if (asrInstance && typeof asrInstance.abort === 'function') {
        asrInstance.abort()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-switch__label.is-active {
    color: #333!important;
}
::v-deep .el-switch__label {
    color: #333!important;
}
.quick-chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 0 4px 8px;
}

.quick-chips button {
  padding: 5px 12px;
  border-radius: 999px;
  border: 1px solid rgba(74, 95, 243, 0.18);
  background: rgba(74, 95, 243, 0.04);
  color: #4a5ff3;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    background: rgba(74, 95, 243, 0.1);
    border-color: rgba(74, 95, 243, 0.35);
    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.96);
  }
}

.claw-input-wrapper {
  flex-shrink: 0;
  padding: 16px 20px;
  // 参考 COSMO-Sphere Client: 输入框水平居中,与消息流同宽
  width: 100%;
  max-width: 880px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

.draft-reference {
  margin-bottom: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(74, 95, 243, 0.06);
  border: 1px solid rgba(74, 95, 243, 0.12);
  animation: slideIn 0.25s ease-out;

  .reference-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .reference-title {
      font-size: 12px;
      font-weight: 700;
      color: #4a5ff3;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .reference-close {
      display: inline-flex;
      width: 22px;
      height: 22px;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.8);
      color: #94a3b8;
      cursor: pointer;
      border: 1px solid rgba(74, 95, 243, 0.15);
      transition: all 0.2s;

      &:hover {
        color: #64748b;
        background: #fff;
      }

      i {
        font-size: 10px;
      }
    }
  }

  .reference-summary {
    margin-top: 4px;
    font-size: 11px;
    color: #64748b;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 待发送追问 chips（参考 COSMO-Sphere Client 输入框上方上下文 chips） */
.followup-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 0 0 8px;
}

.followup-chip {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  padding: 4px 8px 4px 6px;
  border: none;
  border-radius: 6px;
  background: rgba(31, 35, 41, 0.03);
  color: rgba(31, 35, 41, 0.8);
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease;

  &:hover {
    background: rgba(31, 35, 41, 0.06);
  }

  .followup-chip-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    height: 16px;
    min-width: 16px;
    padding: 0 2px;
    border-radius: 4px;
    background: #ffffff;
    color: #1f2329;
    font-size: 10px;
    font-weight: 500;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
    cursor: pointer;
  }

  .followup-chip-text {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }

  .followup-chip-quote {
    font-style: italic;
    color: rgba(31, 35, 41, 0.6);
  }

  .followup-chip-dot {
    margin: 0 4px;
    color: rgba(31, 35, 41, 0.4);
  }
}

.uploaded-files {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.image-preview-card {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  /* 角标删除按钮在卡片外侧右上角，不能 overflow: hidden（img/overlay 已自带圆角） */
  overflow: visible;
  flex-shrink: 0;
  cursor: pointer;

  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
    transition: transform 0.2s;
  }

  .upload-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 6px;
  }
}

/* 附件卡片常驻角标删除按钮（图片 / 文档卡片共用，对齐 UI 图右上角小 ×） */
.file-corner-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
  font-size: 9px;
  color: #9ca3af;
  cursor: pointer;
  z-index: 2;
  transition: all 0.15s;

  &:hover {
    color: #f5222d;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.22);
  }
}

.file-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 8px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  min-width: 200px;
  max-width: 280px;
  transition: all 0.2s;

  &:hover {
    border-color: #c0c4cc;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  }

  .upload-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    z-index: 2;
  }

  .file-type-icon {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .type-label {
      font-size: 9px;
      font-weight: 700;
      color: #fff;
    }
  }

  .file-info {
    flex: 1;
    min-width: 0;

    .file-name {
      font-size: 12px;
      font-weight: 500;
      color: #1f2329;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .file-meta {
      font-size: 10px;
      color: #8f959e;
      margin-top: 1px;
    }
  }
}

/* 文件上传水平进度条 */
.upload-progress-bar {
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  height: 3px;
  background: #e5e7eb;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}
.upload-progress-fill {
  height: 100%;
  background: #4A5FF3;
  border-radius: 0 0 0 8px;
  transition: width 0.3s ease;
}

/* 待发送队列 */
.pending-queue {
  margin-bottom: 8px;
  padding: 6px;
  border: 1px solid #e8ecf0;
  border-radius: 12px;
  background: #fafbfc;
}

.pending-queue-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: #8f959e;
  margin-bottom: 6px;

  .pending-queue-title {
    font-weight: 600;
    color: #4a5ff3;
  }
}

.pending-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 20px;
  transition: background 0.2s;

  &:hover {
    background: #f0f3ff;
  }

  &:hover .pending-actions,
  &:focus-within .pending-actions {
    opacity: 1;
    visibility: visible;
  }
}

.pending-index {
  flex: none;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eef1ff;
  color: #4a5ff3;
  font-size: 10px;
  font-weight: 600;
}

.pending-text {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pending-actions {
  flex: none;
  display: flex;
  align-items: center;
  gap: 2px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, visibility 0.2s;
}

.pending-action {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: #8f959e;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
  transition: all 0.2s;

  &:hover {
    background: #e6ebff;
    color: #4a5ff3;
  }

  &.pending-action--primary {
    color: #4a5ff3;
  }

  &.pending-action--danger:hover {
    background: #ffecec;
    color: #f54a45;
  }
}

.input-box {
  position: relative;
  display: flex;
  align-items: stretch;
  min-height: 144px;
  border-radius: 16px;
  border: 1px solid #e8ecf0;
  padding: 14px 16px;
  // 参考 COSMO-Sphere Client: 输入框恢复白色背景,与消息流透明背景形成层次
  background: #fff;
  transition: all 0.2s;
  overflow: visible;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);

  &:focus-within {
    border: 1px solid #4a5ff3;
    box-shadow: 0 8px 10px 0 #0000000d;
  }

  &.drag-over {
    border-color: #4a5ff3;
    border-style: dashed;
    background: rgba(74, 95, 243, 0.04);
  }

  &.disabled {
    opacity: 0.6;
  }
}

.mention-dropdown {
  position: fixed;
  z-index: 9999;
  width: 360px;
  height: 260px;
  padding: 12px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  // border: 1px solid #e8ecf0;
  overflow: hidden;
  display: flex;

  .mention-close-btn {
    position: absolute;
    top: 4px;
    right: 8px;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    border-radius: 50%;
    cursor: pointer;
    color: #bbb;
    font-size: 16px;
    z-index: 1;
    transition: all 0.2s;

    &:hover {
      background: #f0f0f0;
      color: #666;
    }
  }
  flex-direction: column;

  .mention-header {
    // padding: 10px 14px;
    font-size: 12px;
    color: #000;
    text-align: center;
    font-weight: 600;
    flex-shrink: 0;
  }

  .mention-body {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .mention-item {
    display: flex;
    align-items: center;
    border-radius: 4px;
    gap: 10px;
    padding: 10px 14px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover,
    &.active {
      background: #f0f5ff;
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;

      .mention-name {
        color: #999;
      }
    }

    .mention-avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      line-height: 0;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 14px;
      flex-shrink: 0;
    }

    .mention-info {
      flex: 1;
      min-width: 0;

      .mention-name {
        font-size: 12px;
        font-weight: 600;
        color: #1f2937;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .mention-desc {
        font-size: 11px;
        color: #8c9bab;
        margin-top: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .mention-loading {
    padding: 20px;
    text-align: center;
    color: #8c9bab;
    font-size: 12px;
    i {
      margin-right: 6px;
    }
  }

  .mention-empty {
    padding: 20px;
    text-align: center;
    color: #8c9bab;
    font-size: 12px;
  }

  .mention-back-btn {
    position: absolute;
    top: 10px;
    left: 8px;
    font-size: 12px;
    color: #4a5ff3;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 4px;
    white-space: nowrap;
    &:hover {
      background: #f0f5ff;
    }
  }
}

.mention-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: 26px;
  padding: 0 4px 0 8px;
  margin-bottom: 4px;
  background: linear-gradient(
    135deg,
    rgba(74, 95, 243, 0.1),
    rgba(74, 95, 243, 0.06)
  );
  border: 1px solid rgba(74, 95, 243, 0.25);
  border-radius: 6px;
  font-size: 12px;
  color: #4a5ff3;
  align-self: flex-start;
  animation: mentionChipIn 0.2s ease-out;
  user-select: none;

  .mention-chip-icon {
    font-weight: 700;
    font-size: 13px;
    margin-right: 2px;
  }

  .mention-chip-name {
    font-weight: 600;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mention-chip-close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin-left: 2px;
    border: none;
    background: transparent;
    border-radius: 50%;
    cursor: pointer;
    color: rgba(74, 95, 243, 0.6);
    font-size: 10px;
    padding: 0;
    transition: all 0.15s;

    &:hover {
      background: rgba(74, 95, 243, 0.15);
      color: #4a5ff3;
    }
  }
}

@keyframes mentionChipIn {
  from {
    opacity: 0;
    transform: scale(0.92);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.input-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;

  textarea {
    /* flex-basis: auto 让 JS autoResize 设置的高度作为基准尺寸生效：
       短文本时 grow=1 填满 144px 最小高度；长文本时基准高度撑大输入框至 214px 封顶 */
    flex: 1 1 auto;
    border: none;
    outline: none;
    resize: none;
    font-size: 14px;
    line-height: 1.6;
    padding: 4px 0;
    min-height: 36px;
    max-height: 154px;
    overflow-y: auto;
    font-family: inherit;
    color: #1f2937;
    background: transparent;
    width: 100%;

    &::placeholder {
      color: #9aa9bb;
    }
    &:disabled {
      cursor: not-allowed;
    }
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #d1d5db;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #9ca3af;
    }
  }
}

.input-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-top: 4px;
  margin-top: 20px;
  height: 28px;
  flex-shrink: 0;
}

/* 附件二级菜单（上传文档 / 上传图片） */
.attach-menu-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.attach-menu {
  position: absolute;
  left: 0;
  top: calc(100% + 8px);
  min-width: 120px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(15, 23, 42, 0.12);
  border: 1px solid #eef0f4;
  padding: 6px;
  z-index: 30;

  /* 方向自适应：下方空间不足时向上弹出（会话页输入框贴底场景） */
  &--up {
    top: auto;
    bottom: calc(100% + 8px);
  }
}

.attach-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  color: #1f2937;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;

  i {
    font-size: 15px;
    color: #646a73;
  }

  &:hover {
    background: #f5f6f7;

    i {
      // color: #4a5ff3;
    }
  }
}

.attach-menu-fade-enter-active,
.attach-menu-fade-leave-active {
  transition: opacity 0.15s ease;
}
.attach-menu-fade-enter,
.attach-menu-fade-leave-to {
  opacity: 0;
}

.toolbar-btn {
  width: 30px;
  height: 30px;
  background: #f8f8f8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #f5f5f5;
  cursor: pointer;
  padding: 0;
  font-size: 18px;
  color: #333;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    // background: #e8f0fe;
    // color: #3370ff;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.model-select {
  width: 200px;

  ::v-deep .el-input__inner {
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    border: none;
    text-align: right;
    // padding-right: 5px;
    // background: #f8f8f8;
    border-radius: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.knowledge-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
}

.knowledge-toggle-label {
  font-size: 12px;
  color: #5a6b7e;
  white-space: nowrap;
  line-height: 1;
}

.knowledge-switch {
  margin: 0;
}

.input-actions {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 12px;
  position: absolute;
  right: 14px;
  bottom: 10px;
}

.audio-lines-icon {
  display: inline-block;
}

.audio-lines-icon .bar {
  transform-box: fill-box;
  transform-origin: center;
  transition: transform 0.2s ease;
}

.audio-lines-icon:not(.active) .bar {
  transform: scaleY(0.35);
}

@keyframes audio-lines-wave {
  0%,
  100% {
    transform: scaleY(0.35);
  }
  30% {
    transform: scaleY(0.7);
  }
  50% {
    transform: scaleY(1);
  }
  75% {
    transform: scaleY(0.6);
  }
}

.audio-lines-icon.active .bar1 {
  animation: audio-lines-wave 1s ease-in-out infinite 0s;
}

.audio-lines-icon.active .bar2 {
  animation: audio-lines-wave 1s ease-in-out infinite 0.12s;
}

.audio-lines-icon.active .bar3 {
  animation: audio-lines-wave 1s ease-in-out infinite 0.24s;
}

.audio-lines-icon.active .bar4 {
  animation: audio-lines-wave 1s ease-in-out infinite 0.36s;
}

.audio-lines-icon.active .bar5 {
  animation: audio-lines-wave 1s ease-in-out infinite 0.48s;
}

.action-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
  font-size: 16px;
  color: #646a73;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    // background: #e8f0fe;
    // color: #3370ff;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.voice-btn {
    position: relative;

    /* 录音图片图标：原图 36×36 且字形撑满画布，限制到 18px 避免贴边 */
    .voice-icon-img {
      display: block;
      width: 16px;
      height: 16px;
      object-fit: contain;
    }
  }

  &.recording {
    background: #f7f8fc;
    color: #4a5ff3;

    &:hover:not(:disabled) {
      // background: #f7f8fc;
      // color: #4a5ff3;
    }
  }

  &.stop-btn {
    background: #f5222d;
    color: #fff;
    &:hover {
      background: #ff4d4f;
    }
  }

  &.send-btn {
    background: linear-gradient(135deg, #4a5ff3, #6b7fff);
    color: #fff;
    border-radius: 18px;
    box-shadow: 0 4px 12px rgba(74, 95, 243, 0.3);
    &:hover:not(.disabled) {
      background: linear-gradient(135deg, #3551d8, #5a6fff);
      box-shadow: 0 6px 16px rgba(74, 95, 243, 0.4);
    }
    &.disabled {
      background: #d1d5db;
      color: #fff;
      box-shadow: none;
    }
  }
}
</style>

<!--
  模型选择下拉面板：el-select 的 popper 默认 append 到 body，scoped 样式无法命中，
  故用 popper-class 限定作用域 + 非 scoped 样式块实现（不加 scoped 才能穿透到 body 下的面板）。
  选择器权重高于 main.js 中同名的 !important 全局规则，避免被覆盖。
-->
<style lang="scss">
.model-select-popper {
  .el-select-dropdown__list {
    padding: 6px 12px !important;
    display: flex;
    flex-direction: column;
    gap: 4px;
   }

  .el-select-dropdown__item {
    border-radius: 8px !important;
  }

  .el-select-dropdown__item.selected {
    background: #EDF1FB !important;
  }
}
</style>
